import React from 'react';
import { useNavigate } from '../PlatformFunctionality';
import { ContentBlock } from '../ContentBlock';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { styles } from './SubSnackbars.css';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel/Carousel';
import { SnackbarProps } from '../Contentful/transformers/SnackbarTransformer';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { getSortedList } from '@jbhi-fi/utils/src/sorting/sortOnPriority';

const SubSnackbar = ({ subSnackbars }: { subSnackbars: Array<SnackbarProps> }) => {
  const sortedSnackbars = getSortedList(subSnackbars, 4);

  const navigateTo = useNavigate();
  const handleClick = (url: string | undefined) => {
    if (!url) return;
    navigateTo(url);
  };

  const isMobile = useBreakpoint('lg', 'down');

  const getSubSnackbarContent = () => {
    const backgroundColor = sortedSnackbars[0]?.backgroundColor;
    return sortedSnackbars?.map((item, index) => {
      const { textColor = 'black', content, icon, url } = item;
      return (
        <div
          key={index}
          className={styles.subSnackbarItems}
          onClick={() => handleClick(url)}
          onKeyDown={() => handleClick(url)}
          role="button"
          tabIndex={0}
          style={{ backgroundColor, color: textColor }}
        >
          {icon ? (
            <div>
              <Icon name={icon} />
            </div>
          ) : null}
          {content ? documentToReactComponents(content) : null}
        </div>
      );
    });
  };

  return (
    <ContentBlock className={styles.subSnackbarWrapper}>
      {isMobile ? (
        <Carousel
          slidesOffsetBefore={1}
          slidesOffsetAfter={1}
          showPagination={false}
          variant="autoPlayCarousel"
          centeredSlides={false}
          showArrows={false}
          fullBleed
          className="carousalClass"
        >
          {getSubSnackbarContent()}
        </Carousel>
      ) : (
        <div tabIndex={0} role="button" className={styles.subSnackbarContent}>
          {getSubSnackbarContent()}
        </div>
      )}
    </ContentBlock>
  );
};

export { SubSnackbar };
